import React, { FC, useContext } from 'react';
import { UiStateContext } from '../../context/UiStateContext';
import { Kfh_ArtirixImageType } from '../../types/graphqlTypes';
import Blade from '../Blade';
import { Button } from '../Button';
import { ImageGallery } from '../icon/icons/ImageGallery';
import { Img } from '../Img';
import { Spacer } from '../Spacer';

interface PropertyFloorplanBladeProps {
  floorplans: Kfh_ArtirixImageType[];
}

export const PropertyFloorplanBlade: FC<PropertyFloorplanBladeProps> = ({ floorplans }) => {
  const { setActiveBlade } = useContext(UiStateContext);
  return (
    <Blade
      id="propertyFloorplan"
      width="wide"
      heading="Floorplan"
      hideFooterOnDesktop
      customHeaderComponent={
        <Button
          variant="pill"
          onClick={() => setActiveBlade('propertyPhotoGallery')}
          type="button"
          iconLeft={<ImageGallery />}
          eventClickBladeId="propertyPhotoGallery"
        >
          Photos
        </Button>
      }
    >
      <Spacer>
        {floorplans?.map((media, i: number) => (
          <Img
            src={media}
            key={i}
            options={{
              width: 896,
              layout: 'constrained',
              cropFocus: 'center',
              placeholder: 'none',
              quality: 80,
              backgroundColor: '#F5F5F5',
            }}
            size="827x552"
          />
        ))}
      </Spacer>
    </Blade>
  );
};

export default PropertyFloorplanBlade;
